import React from "react";
import { Alert } from "antd";

/** Aviso del bloqueo vigente. accion: "solicitar" (colaborador) o "aprobar" (aprobador). */
const AvisoBloqueoMovimientos = ({ fechaLimite, accion = "solicitar", style }) => {
	if (!fechaLimite) {
		return null;
	}
	const hasta = fechaLimite.format("DD/MM/YYYY");
	const desde = fechaLimite.clone().add(1, "day").format("DD/MM/YYYY");
	const mensaje =
		accion === "aprobar"
			? `Movimientos bloqueados hasta el ${hasta}. Solo puede aprobar solicitudes con fecha de inicio a partir del ${desde}; las anteriores solo pueden rechazarse.`
			: `Movimientos bloqueados hasta el ${hasta}. Solo puede solicitar con fecha de inicio a partir del ${desde}.`;
	return <Alert showIcon type="warning" message={mensaje} style={{ marginBottom: 12, ...style }} />;
};

export default AvisoBloqueoMovimientos;
